import "./FootRefrigeratedTrailerRentals.module.css";
import Header from "@/reusable_sections/Header";
import TrailerHero from "./sections/TrailerHero";
import Overview from "./sections/Overview";
import Applications from "./sections/Applications";
import Specifications from "./sections/Specifications";
import Coverage from "./sections/Coverage";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function FootRefrigeratedTrailerRentalsPage() {
  return <div>
      <Header />
      <TrailerHero />
      <Overview />
      <Applications />
      <Specifications />
      <Coverage />
      <CallToAction />
      <Footer />
    </div>;
}